import React from 'react';

const PlusIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24">
    <path d="m13 4v7h7v2h-7v7h-2v-7h-7v-2h7v-7z" />
  </svg>
);

export default PlusIcon;
